import tutorialStyle from "../tutorial.module.css";
import { TooltipRenderProps } from "react-joyride";
import Button from "../../../Common/Button/Button";

export function CustomTooltip(props: Readonly<TooltipRenderProps>) {
  const { backProps, continuous, index, primaryProps, skipProps, step, tooltipProps } = props;

  const extendedWidthClass = step.data?.image ? tutorialStyle.extendedWidth : "";

  return (
    <div className={tutorialStyle.stepWrapper + " " + extendedWidthClass} {...tooltipProps}>
      {step.title && <h4 className={tutorialStyle.stepTitle}>{step.title}</h4>}
      <div className={tutorialStyle.stepContent}>{step.content}</div>

      {step.data?.image && <img alt="Screenshot" className={tutorialStyle.image} src={step.data.image}/>}

      <div className={tutorialStyle.footer}>
        {step.data?.skip && (
          <Button variant="tertiary" {...skipProps}>
            {skipProps.title}
          </Button>
        )}

        <div className={tutorialStyle.spacer} />
        {index > 0 && step.data?.back && (
          <Button variant="secondary" {...backProps}>
            {backProps.title}
          </Button>
        )}
        {continuous && step.data?.next && (
          <Button variant="primary" textcolor="dark" {...primaryProps}>
            {primaryProps.title}
          </Button>
        )}
      </div>
    </div>
  );
}
